import { Button, Card, Space, Typography } from "antd";
import { LinkOutlined } from "@ant-design/icons";

const APP_URL = import.meta.env.VITE_MAIN_APP_URL || "https://app.example.com";

export const RemoteDenied = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        padding: 32,
      }}
    >
      <Card style={{ maxWidth: 480, width: "100%" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Typography.Title level={3}>Remote access denied</Typography.Title>
          <Typography.Paragraph>
            Your session either expired or does not grant permission to reach this concentrator.
            Please return to the Smart Tech App to sign back in or request access.
          </Typography.Paragraph>
          <Button
            type="primary"
            href={APP_URL}
            icon={<LinkOutlined />}
            block
          >
            Back to app
          </Button>
        </Space>
      </Card>
    </div>
  );
};
